module.exports = __webpack_public_path__ + "img/view_permissions.2e7b7293.svg";